import { render, staticRenderFns } from "./ShareAccess.vue?vue&type=template&id=43135511&scoped=true&"
import script from "./ShareAccess.vue?vue&type=script&lang=ts&"
export * from "./ShareAccess.vue?vue&type=script&lang=ts&"
import style0 from "./ShareAccess.vue?vue&type=style&index=0&id=43135511&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43135511",
  null
  
)

export default component.exports